import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import EventModal from '../components/EventModal';
import EventPost from '../components/EventPost';

import {
  useEventsState,
  useEventsActions
} from './EventsContext';
import EventsLoader from './EventsLoader';
import Button from '../../Shared/UI/Button/components/Button';

import { getEvents } from './restApi';

import styles from './Events.module.scss';

const EventsContent = ({ timezones }) => {
  const state = useEventsState();
  const { setEventWizardOpen, onResponse, onError } = useEventsActions();

  const openEventWizard = (e) => {
    e.preventDefault();
    setEventWizardOpen(true);
  };

  const events = () => {
    return (state.eventData || []).map(event => {
      return (
        <EventPost
          key={event.id}
          event={event}
        />
      );
    });
  }

  const loadMoreEvents = () => {
    getEvents({
      lastPageViewed: state?.lastPageViewed || 0,
      onResponse: (data) => onResponse(data),
      onError: (feedback) => onError(feedback),
    });
  };

  return (
    <>
      <div id={styles.infinitScrollContainer}>
        <InfiniteScroll
          dataLength={(state?.eventData || []).length}
          next={loadMoreEvents}
          hasMore={state?.canViewMoreEvents ?? true}
          loader={<h4>Loading...</h4>}
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>You've seen all the events</b>
            </p>
          }
          scrollableTarget={styles.infinitScrollContainer}
        >
          <div id={styles.createEventsContainer}>
            <Button variant="primary" onClick={openEventWizard}>Make an event</Button>
          </div>
          {events()}
        </InfiniteScroll>
      </div>
      <EventModal
        wizardOpen={state?.eventWizardOpen}
        timezones={timezones}
      />
    </>
  );
};

export default function Events({ timezones }) {
  return (
    <>
      <EventsLoader />
      <EventsContent timezones={timezones} />
    </>
  );
}
